import { createApiSlice } from "@common";
import { CRUD_COMPETITOR_THREAT_LEVEL } from "@routes";

const apiConfig = [
  {
    name: "addCompetitorThreatLevel",
    method: "post",
    url: CRUD_COMPETITOR_THREAT_LEVEL,
    stateKey: "message",
  },
  {
    name: "getCompetitorThreatLevel",
    method: "get",
    url: CRUD_COMPETITOR_THREAT_LEVEL,
    stateKey: "data",
  },
  {
    name: "updateCompetitorThreatLevel",
    method: "put",
    url: CRUD_COMPETITOR_THREAT_LEVEL,
    stateKey: "message",
  },
  {
    name: "deleteCompetitorThreatLevel",
    method: "delete",
    url: CRUD_COMPETITOR_THREAT_LEVEL,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"competitorThreatLevel",
 apiConfig, 
 customReducers);
const competitorThreatLevelSlice = slice;

export default competitorThreatLevelSlice.reducer;

export const {
  addCompetitorThreatLevel,
  getCompetitorThreatLevel,
  updateCompetitorThreatLevel,
  deleteCompetitorThreatLevel,
} = thunks;

export const { rowSelect } = actions;
